const BikeIcon = ({ className, ...props }) => (
  <svg
    height="45"
    id="electric_scooter-24px"
    className={`MuiSvgIcon-root ${className}`}
    viewBox="0 0 47 39.051"
    width="47"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g data-name="Groupe 381" id="Groupe_381">
      <path
        d="M15.717,35.456H32.636v-2.3a9.307,9.307,0,0,1,9.426-9.188h1.744L39.328,4.583A4.709,4.709,0,0,0,34.733,1L31.311,2.69v.831l3.423,2.073,3.3,14.357h-.024a13.924,13.924,0,0,0-9.873,10.911H15.717a7.087,7.087,0,0,0-8.059-4.456A6.878,6.878,0,0,0,9.072,40.051,7.084,7.084,0,0,0,15.717,35.456Zm-6.645,0a2.3,2.3,0,1,1,2.356-2.3A2.334,2.334,0,0,1,9.072,35.456Z"
        data-name="Tracé 3014"
        id="Tracé_3014"
        transform="translate(-1.998 -1)"
      />
      <path
        d="M22.891,12a6.891,6.891,0,1,0,6.891,6.891A6.882,6.882,0,0,0,22.891,12Zm0,9.188a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,22.891,21.188Z"
        data-name="Tracé 3015"
        id="Tracé_3015"
        transform="translate(17.217 13.268)"
      />
    </g>
  </svg>
);

export default BikeIcon;
